import { render } from "./CompaniesHouseList.vue?vue&type=template&id=0f756f58"
import script from "./CompaniesHouseList.vue?vue&type=script&lang=js"
export * from "./CompaniesHouseList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__